import React from "react";
import type { NextPage } from "next";
import Image from "next/image";
import ahambg from "@/assets/images/aham1.jpg";
import styles from "@/styles/houseOfSenco.module.scss";

const Aham = () => {
  return (
    <div
      className={styles.aham}
      onClick={() =>
        window.open(
          "https://sencogoldanddiamonds.com/jewellery/category/aham-collection",
          "_blank"
        )
      }
      style={{ cursor: "pointer" }}
    >
      <div className={styles.image_aham}>
        <Image src={ahambg} alt="" />
      </div>
      <div className={styles.aham_overlay}>
        <div className={styles.container}>
          <div className={styles.aham_card}>
            <div className={styles.sen_text}>Aham</div>
            <p>
              Designed for modern and sophisticated gentlemen to command
              attention, Aham’s Men Jewellery by Senco exudes dignified
              demeanour and cosmopolitan flair. Express your appreciation for
              fine craftsmanship and luxury with our signature collection of
              rings, bracelets, cufflinks, ear-studs, chains and pendants.
              Meticulously crafted in platinum, diamond, gold and silver, Aham
              jewellery speaks with a refined and timeless voice.
            </p>
            {/* <a>VISIT WEBSITE</a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aham;
